import { useIntl } from "react-intl";

export const useTranslationBulletPoints = () => {
  const intl = useIntl();

  // BULLET POINTS
  const bulletPointsTitle = intl.formatMessage({
    defaultMessage: "Why Choose Us",
    id: "home.section.bulletsPointSection.title",
  });

  // First paragraph
  const bulletsPointParaphraphe1TitleTranslation = intl.formatMessage({
    defaultMessage: "Relevant",
    id: "home.section.bulletsPointParagraphe1.title",
  });

  const bulletsPointParaphraphe1BTitleTranslation = intl.formatMessage({
    defaultMessage: "Your commercial playbook.",
    id: "home.section.bulletsPointParagraphe1.b.title",
  });

  const bulletsPointParaphraphe1TextTranslation = intl.formatMessage({
    defaultMessage:
      "Makes the best product recommendations based on your inventory and customer demand",
    id: "home.section.bulletsPointParagraphe1.text",
  });

  const bulletsPointParaphraphe1BTextTranslation = intl.formatMessage({
    defaultMessage:
      "Speaks in your brand voice, follows your rules, and sells your way. Every answer feels consistent—like your best rep, on their best day.",
    id: "home.section.bulletsPointParagraphe1.b.text",
  });

  // Second paragraph

  const bulletsPointParaphraphe2TitleTranslation = intl.formatMessage({
    defaultMessage: "Listening",
    id: "home.section.bulletsPointParagraphe2.title",
  });
  const bulletsPointParaphraphe2TextTranslation = intl.formatMessage({
    defaultMessage:
      "Really understands your customers and their purchase intent before responding to them",
    id: "home.section.bulletsPointParagraphe2.text",
  });
  const bulletsPointParaphraphe2bTitleTranslation = intl.formatMessage({
    defaultMessage: "Catalog-intelligent",
    id: "home.section.bulletsPointParagraphe2.b.title",
  });
  const bulletsPointParaphraphe2bTextTranslation = intl.formatMessage({
    defaultMessage:
      "Understands specs, constraints, compatibility, and real trade-offs. Not “here are options”—it explains why this is the right fit.",
    id: "home.section.bulletsPointParagraphe2.b.text",
  });

  // Third paragraph

  const bulletsPointParaphraphe3TitleTranslation = intl.formatMessage({
    defaultMessage: "Flexible",
    id: "home.section.bulletsPointParagraphe3.title",
  });
  const bulletsPointParaphraphe3TextTranslation = intl.formatMessage({
    defaultMessage:
      "Adjusts to customer requests to always provide an appropriate response",
    id: "home.section.bulletsPointParagraphe3.text",
  });
  const bulletsPointParaphraphe3bTitleTranslation = intl.formatMessage({
    defaultMessage: "Grounded recommendations",
    id: "home.section.bulletsPointParagraphe3.b.title",
  });
  const bulletsPointParaphraphe3bTextTranslation = intl.formatMessage({
    defaultMessage:
      "Recommends from real stock and real business logic—not vibes. Customers get confident picks you can actually fulfill.",
    id: "home.section.bulletsPointParagraphe3.b.text",
  });

  return {
    bulletsPointParaphraphe1TitleTranslation,
    bulletsPointParaphraphe1TextTranslation,
    bulletsPointParaphraphe2TitleTranslation,
    bulletsPointParaphraphe2TextTranslation,
    bulletsPointParaphraphe3TitleTranslation,
    bulletsPointParaphraphe3TextTranslation,
    bulletsPointParaphraphe1BTitleTranslation,
    bulletsPointParaphraphe1BTextTranslation,
    bulletsPointParaphraphe2bTitleTranslation,
    bulletsPointParaphraphe2bTextTranslation,
    bulletsPointParaphraphe3bTitleTranslation,
    bulletsPointParaphraphe3bTextTranslation,
    bulletPointsTitle,
  };
};
